import { render, staticRenderFns } from "./ReportIssue.vue?vue&type=template&id=4ad20b66&scoped=true"
import script from "./ReportIssue.vue?vue&type=script&lang=js"
export * from "./ReportIssue.vue?vue&type=script&lang=js"
import style0 from "./ReportIssue.vue?vue&type=style&index=0&id=4ad20b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad20b66",
  null
  
)

export default component.exports